import { ApiLoggingUtils } from 'api/ApiLoggingUtils';
import { ApiUtils } from 'api/ApiUtils';
import * as R from 'ramda';
import { JsonSafe } from 'utils/JsonSafe';
import { LogHelper } from 'utils/LogHelper';

const SDKLogger = {
    createSingleRequestLogger,
};

export { SDKLogger };
function createSingleRequestLogger({
    group,
    logResponseTextOnError,
    method,
    url,
    backendType,
}) {
    const startTime = LogHelper.getPerformanceNow();

    const loggingHeaders = ApiUtils.getCommonRequestHeaders();

    return {
        getLoggingHeaders() {
            return loggingHeaders;
        },

        logXhrOnResponse({ xhr, customData = {} }) {
            this.logOnResponse({
                status: xhr.status,
                responseText: JsonSafe.stringify(
                    xhr.response || xhr.responseText,
                ),

                getResponseHeader: (headerName) => {
                    return _getHeaderCaseInsensitive(headerName, xhr);
                },

                customData: {
                    ...customData,
                    readyState: xhr.readyState,
                },
            });
        },

        logOnResponse({ status, responseText, getResponseHeader, customData }) {
            ApiLoggingUtils.logApiResponse({
                group,
                method,
                url,
                loggingHeaders,
                startTime,
                endTime: LogHelper.getPerformanceNow(),
                status,
                logResponseTextOnError,
                responseText,
                getResponseHeader,
                customData,
                backendType,
            });
        },
    };
}

const _getHeaderCaseInsensitive = (headerName, xhr) => {
    const headerString = xhr.getAllResponseHeaders();

    const headers = R.mergeAll(
        headerString
            .split('\n')
            .map((i) => i.split(': '))
            .map(([key, value]) => ({
                [key.toLowerCase()]: value,
            })),
    );

    return headers[headerName.toLowerCase()];
};
